import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from '../index';

export default function VerticalBox({ children, ...rest }) {
  return (
    <Flex justifyContent="center" flexDirection="column" alignItems="center" {...rest}>
      <Box>
        { children }
      </Box>
    </Flex>
  );
}

VerticalBox.propTypes = {
  children: PropTypes.any,
};
